// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3NsWJ","inner":"Form_inner__1ojOI","range":"Form_range__2Uu2U","name":"Form_name__2idaJ","actions":"Form_actions__10VLW"};